import { logError } from 'utils/logger';
import { useMutation } from '@apollo/client';
import { UPDATE_CREDIT_SUBMISSION } from '../api';

export function useCreditSubmission() {
  const [onUpdateCreditSubmission, { loading }] = useMutation(UPDATE_CREDIT_SUBMISSION);

  const handleUpdateCreditSubmission = async (dynamicsCreditSubmissionId: string, fieldsObj: Record<string, any>) => {
    if (!dynamicsCreditSubmissionId) return;

    try {
      await onUpdateCreditSubmission({ variables: { input: { dynamicsCreditSubmissionId, ...fieldsObj } } });
    } catch (error) {
      logError(error);
    }
  };

  return {
    isUpdating: loading,
    handleUpdateCreditSubmission,
  };
}
